import { setDocumentsData } from '@cp/src/reducers/agentDocumentSlice';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';
import { Dispatch } from '@reduxjs/toolkit';

export const getAgentDocuments = () => async (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.FETCH_AGENT_DOCUMENTS);
  await axiosInstance
    .get(url)
    .then(res => {
      if (res?.status === API_STATUS_CODE.OK) dispatch(setDocumentsData(res?.data));
    })
    .catch(err => {
      logError(err);
    });
};
